// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"627":"6c836f09","714":"3737af4c","858":"527cc0fb","925":"57db9810","934":"ed4d264c"}[chunkId] + ".chunk.css";
};